let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("adH3p")).then(() => parcelRequire('f6IRL'));